<template>
    <div class="relative">
        <div class="container">
            <div class="flex flex-col">
                <div class="w-full grid gap-y-7 grid-cols-1 md:gap-x-6 lg:grid-cols-3 xlg:gap-x-[30px] xlg:grid-cols-3">
                    <box-post v-for="post in printPosts" :post="post" :key="`services-post-${post.id}`"></box-post>
                </div>

                <div @click="viewMore"
                     v-show="currentPosts.length > customPostsPerPage"
                     class="cursor-pointer btn btn--secondary block mt-10 mx-auto md:mt-20 lg:mt-10">
                    <span>Load all services</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import boxPost from "./partials/box-post";

export default {
    name: "services-posts",
    props: {
        data: [String],
    },
    data() {
        return {
            posts: JSON.parse(this.data),
            customPostsPerPage: 3,
            currentPosts: [],
        }
    },
    components: {
        boxPost,
    },
    mounted() {
        this.currentPosts = this.posts;
        
        if ( window.innerWidth >= 1024 )
            this.customPostsPerPage = 6;
    },
    computed: {
        printPosts() {
            return this.currentPosts.slice(0, this.customPostsPerPage);
        },
    },
    methods: {
        viewMore() {
            this.customPostsPerPage += (window.innerWidth >= 1024 ? 6 : 3);
        },
    },
}
</script>

<style scoped lang="scss">
</style>